var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23.477,
    viewBox: "0 0 24.5 23.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-shopping-cart",
    "data-name": "Icon feather-shopping-cart",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M14.045,31.023A1.023,1.023,0,1,1,13.023,30,1.023,1.023,0,0,1,14.045,31.023Z",
    transform: "translate(-3.341 -9.068)",
    fill: "none",
    stroke: "#4c2664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M30.545,31.023A1.023,1.023,0,1,1,29.523,30,1.023,1.023,0,0,1,30.545,31.023Z",
    transform: "translate(-8.591 -9.068)",
    fill: "none",
    stroke: "#4c2664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1.5,1.5H5.591L8.332,15.194a2.045,2.045,0,0,0,2.045,1.647h9.941a2.045,2.045,0,0,0,2.045-1.647L24,6.614H6.614",
    fill: "none",
    stroke: "#4c2664",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.581b3fb239749bdd10fd18da099623fc.svg";
export { ForwardRef as ReactComponent };